<script>
import DownloadFile from "@/mixins/DownloadFile";

export default {
    name: "VFileInputUpload",
    inheritAttrs: false,
    mixins: [
        DownloadFile,
    ],
    props: {
        value: {
            type: String,
        },
        uploadUrl: {
            type: String,
            required: true,
        },
        uploadName: {
            type: String,
            default: 'image',
        },
        loading: {
            type: Boolean,
        },
        download: {
            type: Boolean,
        },
    },
    data() {
        return {
            isLoading: false,
            fileRaw: null,
            key: 1,
        };
    },
    computed: {
        file: {
            get() {
                return this.fileRaw || (this.syncValue ? {name: this.syncValue, fake: true, key: this.key} : null);
            },
            set(v) {
                this.fileRaw = v;
            },
        },
        syncValue: {
            get() {
                return this.value;
            },
            set(v) {
                this.$emit('input', v);
                this.key++;
            },
        },
        canDownload() {
            return this.download && this.file?.fake || false;
        },
    },
    methods: {
        onChangeFile(fileObject) {
            if (!fileObject) {
                this.syncValue = '';
                return;
            }
            if (fileObject.fake) {
                return;
            }

            const formData = new FormData();

            formData.append(this.uploadUrl, fileObject);

            this.isLoading = false;

            this.$api.request({
                url: this.uploadUrl,
                method: "POST",
                data: formData,
                headers: {
                    "Content-Type": "multipart/form-data"
                },
            })
                .then(response => {
                    this.syncValue = response.data.data.file;
                })
                .catch((e) => {
                    this.notifyError(e);
                })
                .finally(() => {
                    this.file = null;
                    this.isLoading = false;
                });
        },
        onClickDownload() {
            this.getFile(this.file.name);
        },
    }
}
</script>

<template>
    <v-file-input
        v-bind="$attrs"
        v-on="$listeners"
        :value="file"
        :loading="isLoading"
        :append-icon="canDownload ? 'mdi-download' : ''"
        @click:append="onClickDownload"
        @change="onChangeFile"
        @click:clear="$emit('clear'); syncValue = ''"
    >
        <template v-for="(_, slot) of $slots" v-slot:[slot]>
            <slot :name="slot"></slot>
        </template>
    </v-file-input>
</template>

<style scoped lang="scss">

</style>
